import React, { useState } from 'react';

const ScratchpadPanel = ({
  items = [],
  onRemove,
  onClearAll,
  onClearDate,
  onClose,
  onPlayerClick,
  getTeamLogoUrl,
  isMobile,
  marketBannerBottom,
  // Tab-switcher props — when betslipOpen is true the header shows a tabbed
  // Betslip/Scratchpad switcher instead of the standalone title.
  betslipOpen = false,
  betslipCount = 0,
  onSwitchToBetslip,
  // Filter toggle — when on, the odds screen for the current sport is
  // restricted to today's scratchpad players. Owned in App.js so the filter
  // state can drive the player tables.
  filterEnabled = false,
  onToggleFilter,
}) => {
  // Active day tab — matches the server's 2-day rolling window.
  const [activeDateTab, setActiveDateTab] = useState('today');

  // Date keys for today/yesterday (match both YYYYMMDD and YYYY-MM-DD).
  const __now = new Date();
  const __padYmd = (d) => `${d.getFullYear()}${String(d.getMonth() + 1).padStart(2, '0')}${String(d.getDate()).padStart(2, '0')}`;
  const todayKeyA = __padYmd(__now);
  const todayKeyB = __now.toISOString().slice(0, 10);
  const __yesterday = new Date(Date.now() - 24 * 60 * 60 * 1000);
  const yesterdayKeyA = __padYmd(__yesterday);
  const yesterdayKeyB = __yesterday.toISOString().slice(0, 10);
  const keyOfItem = (it) => it.gameDateKey
    || (it.addedAt ? new Date(it.addedAt).toISOString().slice(0, 10) : 'older');
  const isToday = (it) => {
    const k = keyOfItem(it);
    return k === todayKeyA || k === todayKeyB;
  };
  const isYesterday = (it) => {
    const k = keyOfItem(it);
    return k === yesterdayKeyA || k === yesterdayKeyB;
  };
  const todayCount = items.filter(isToday).length;
  const yesterdayCount = items.filter(isYesterday).length;
  const desktopStyle = {
    position: 'fixed',
    top: `${marketBannerBottom || 130}px`,
    right: '5px',
    width: '400px',
    bottom: 0,
    backgroundColor: '#000',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    borderLeft: '1px solid #333',
    borderRadius: '12px',
    transition: 'left 0.2s ease, width 0.2s ease',
  };

  const mobileStyle = {
    position: 'fixed',
    top: `${marketBannerBottom || 130}px`,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.95)',
    zIndex: 1100,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    borderTopLeftRadius: '12px',
    borderTopRightRadius: '12px',
  };

  return (
    <div className="dark-panel" style={isMobile ? mobileStyle : desktopStyle}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 12px', borderBottom: '1px solid #333', flexShrink: 0 }}>
        {betslipOpen ? (
          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
            <button
              onClick={onSwitchToBetslip}
              style={{
                background: 'transparent', border: 'none', cursor: 'pointer',
                color: '#9ca3af', fontFamily: "'Oswald', sans-serif", fontSize: '0.95rem', fontWeight: 600,
                borderBottom: '2px solid transparent', padding: '4px 8px',
              }}
            >
              BETSLIP{betslipCount > 0 ? ` (${betslipCount})` : ''}
            </button>
            <button
              style={{
                background: 'transparent', border: 'none', cursor: 'default',
                color: '#a78bfa', fontFamily: "'Oswald', sans-serif", fontSize: '0.95rem', fontWeight: 600,
                borderBottom: '2px solid #a78bfa', padding: '4px 8px',
              }}
            >
              SCRATCHPAD{items.length > 0 ? ` (${items.length})` : ''}
            </button>
          </div>
        ) : (
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M3 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4z" stroke="#a78bfa" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
              <path d="M7 9h10M7 13h10M7 17h6" stroke="#a78bfa" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <span style={{ color: '#a78bfa', fontFamily: "'Oswald', sans-serif", fontSize: '1rem', fontWeight: '600' }}>SCRATCHPAD</span>
            {items.length > 0 && (
              <span style={{ color: '#6c757d', fontSize: '0.8rem' }}>({items.length})</span>
            )}
          </div>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          {onToggleFilter && (
            <button
              onClick={() => onToggleFilter(!filterEnabled)}
              title={filterEnabled ? 'Filter is on — odds screen shows only today’s scratchpad players' : 'Filter the odds screen to only today’s scratchpad players'}
              style={{
                background: filterEnabled ? '#a78bfa' : 'transparent',
                border: `1px solid ${filterEnabled ? '#a78bfa' : '#6c757d'}`,
                color: filterEnabled ? '#000' : '#9ca3af',
                fontSize: '0.7rem',
                fontWeight: 600,
                padding: '2px 8px',
                borderRadius: '4px',
                cursor: 'pointer',
                textTransform: 'uppercase',
                letterSpacing: '0.04em',
              }}
            >
              Filter
            </button>
          )}
          {items.length > 0 && onClearAll && (
            <button
              onClick={onClearAll}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#9ca3af',
                fontSize: '0.75rem',
                cursor: 'pointer',
                padding: '2px 4px',
                textDecoration: 'underline',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.color = '#fff'; }}
              onMouseLeave={(e) => { e.currentTarget.style.color = '#9ca3af'; }}
            >
              Clear All
            </button>
          )}
          <button
            onClick={onClose}
            style={{ background: 'transparent', border: 'none', color: '#fff', fontSize: '20px', cursor: 'pointer', lineHeight: 1, padding: '0 4px' }}
          >
            ×
          </button>
        </div>
      </div>

      {/* Tab strip — Today / Yesterday matches the server's 2-day window */}
      <div style={{ display: 'flex', alignItems: 'stretch', borderBottom: '1px solid #2a2d31', flexShrink: 0 }}>
        {[
          { key: 'today', label: 'Today', count: todayCount, activeDateKey: todayKeyA },
          { key: 'yesterday', label: 'Yesterday', count: yesterdayCount, activeDateKey: yesterdayKeyA },
        ].map(tab => (
          <button
            key={tab.key}
            onClick={() => setActiveDateTab(tab.key)}
            style={{
              flex: 1,
              background: 'transparent',
              border: 'none',
              padding: '10px 12px',
              color: activeDateTab === tab.key ? '#a78bfa' : '#9ca3af',
              borderBottom: activeDateTab === tab.key ? '2px solid #a78bfa' : '2px solid transparent',
              fontFamily: "'Oswald', sans-serif",
              fontSize: '0.85rem',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              cursor: 'pointer',
            }}
          >
            {tab.label}{tab.count > 0 ? ` (${tab.count})` : ''}
          </button>
        ))}
      </div>

      {/* Body */}
      <div style={{ flex: 1, overflow: 'auto', padding: '12px' }}>
        {items.length === 0 ? (
          <div style={{ color: '#6c757d', fontSize: '0.85rem', textAlign: 'center', padding: '40px 12px', lineHeight: 1.5 }}>
            No players in the scratchpad yet.<br />
            Right-click a player and choose <em>Add to Scratchpad</em>.
          </div>
        ) : (() => {
          // Filter items to the active tab's day (Today or Yesterday) and
          // group what's left by sport (MLB → soccer order).
          const SPORT_ORDER = ['mlb', 'nba', 'wnba', 'nhl', 'nfl', 'ncaaf', 'ncaab', 'soccer'];
          const SPORT_LABEL = {
            mlb: 'MLB', nba: 'NBA', wnba: 'WNBA', nhl: 'NHL',
            nfl: 'NFL', ncaaf: 'NCAAF', ncaab: 'NCAAB', soccer: 'Soccer',
          };

          const visibleItems = items.filter(activeDateTab === 'today' ? isToday : isYesterday);
          if (visibleItems.length === 0) {
            return (
              <div style={{ color: '#6c757d', fontSize: '0.85rem', textAlign: 'center', padding: '40px 12px', lineHeight: 1.5 }}>
                No players for {activeDateTab === 'today' ? 'today' : 'yesterday'}.
              </div>
            );
          }

          const sportsObj = {};
          visibleItems.forEach((it) => {
            const sKey = (it.sport || 'other').toLowerCase();
            if (!sportsObj[sKey]) sportsObj[sKey] = [];
            sportsObj[sKey].push(it);
          });

          const orderedSportKeys = [
            ...SPORT_ORDER.filter(k => sportsObj[k]),
            ...Object.keys(sportsObj).filter(k => !SPORT_ORDER.includes(k)).sort(),
          ];

          const activeDateKey = activeDateTab === 'today' ? todayKeyA : yesterdayKeyA;

          return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {/* Per-tab Clear sits above the sport groups */}
              {onClearDate && (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <button
                    onClick={() => onClearDate(activeDateKey)}
                    style={{
                      background: 'transparent',
                      border: 'none',
                      color: '#9ca3af',
                      fontSize: '0.7rem',
                      cursor: 'pointer',
                      padding: '2px 4px',
                      textDecoration: 'underline',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.color = '#fff'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.color = '#9ca3af'; }}
                  >
                    Clear {activeDateTab === 'today' ? 'Today' : 'Yesterday'}
                  </button>
                </div>
              )}
              {orderedSportKeys.map((sportKey) => (
                <div key={sportKey} style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                    color: '#9ca3af',
                    fontFamily: "'Oswald', sans-serif",
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    textTransform: 'uppercase',
                    letterSpacing: '0.05em',
                    borderBottom: '1px solid #2a2d31',
                    paddingBottom: '3px',
                  }}>
                    <span>{SPORT_LABEL[sportKey] || sportKey.toUpperCase()}</span>
                    <span style={{ color: '#6c757d', fontWeight: 400 }}>({sportsObj[sportKey].length})</span>
                  </div>
                  {sportsObj[sportKey].map((it) => (
              <div
                key={`${it.gameId}-${it.playerId}`}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '8px',
                  padding: '8px 10px',
                  backgroundColor: '#1a1d21',
                  border: '1px solid #2a2d31',
                  borderRadius: '6px',
                }}
              >
                <div
                  style={{ display: 'flex', alignItems: 'center', gap: '8px', minWidth: 0, cursor: onPlayerClick ? 'pointer' : 'default', flex: 1 }}
                  onClick={() => onPlayerClick && onPlayerClick(it)}
                >
                  {it.teamAbbr && getTeamLogoUrl && (
                    <img
                      src={getTeamLogoUrl(it.teamAbbr)}
                      alt={it.teamAbbr}
                      style={{ width: '18px', height: '18px', flexShrink: 0 }}
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                  )}
                  <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'baseline', gap: '6px', minWidth: 0 }}>
                      <span style={{ color: '#fff', fontSize: '0.85rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {it.name}
                      </span>
                      {it.teamAbbr && (
                        <span style={{ color: '#6c757d', fontSize: '0.7rem', flexShrink: 0 }}>{it.teamAbbr}</span>
                      )}
                    </div>
                    {(it.awayTeam || it.homeTeam) && (
                      <div style={{ display: 'flex', alignItems: 'center', gap: '4px', marginTop: '2px' }}>
                        {it.awayTeam && getTeamLogoUrl && (
                          <img
                            src={getTeamLogoUrl(it.awayTeam)}
                            alt={it.awayTeam}
                            style={{ width: '12px', height: '12px', flexShrink: 0 }}
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        )}
                        <span style={{ color: '#9ca3af', fontSize: '0.7rem', whiteSpace: 'nowrap' }}>
                          {it.awayTeam || '?'} <span style={{ color: '#6c757d' }}>vs</span> {it.homeTeam || '?'}
                        </span>
                        {it.homeTeam && getTeamLogoUrl && (
                          <img
                            src={getTeamLogoUrl(it.homeTeam)}
                            alt={it.homeTeam}
                            style={{ width: '12px', height: '12px', flexShrink: 0 }}
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        )}
                      </div>
                    )}
                  </div>
                </div>
                <button
                  onClick={(e) => { e.stopPropagation(); onRemove && onRemove(it); }}
                  style={{
                    background: 'transparent',
                    border: 'none',
                    color: '#9ca3af',
                    fontSize: '16px',
                    cursor: 'pointer',
                    padding: '2px 6px',
                    flexShrink: 0,
                  }}
                  title="Remove from scratchpad"
                >
                  ×
                </button>
              </div>
            ))}
                </div>
              ))}
            </div>
          );
        })()}
      </div>
    </div>
  );
};

export default ScratchpadPanel;
